import { useEffect, useState } from "react";
import { fetchEvents } from "../functions/fetchEvents";

export default function useScenarioEventsData(selectedKpi) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const monitoringType = selectedKpi?.monitoring?.type;

  useEffect(() => {
    if (monitoringType !== "events") {
      setEvents([]);
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchEvents();
        if (!cancelled) setEvents(data);
      } catch (err) {
        if (!cancelled) {
          setError(err);
          setEvents([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [monitoringType]);

  return { events, loading, error };
}
